module.exports = __webpack_public_path__ + "img/yellow-icon(3).3ddc6855.png";